var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPositiveRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.075 3.59995L2.175 6.49995C1.99167 6.68328 1.75833 6.77495 1.475 6.77495C1.19167 6.77495 0.958333 6.68328 0.775 6.49995C0.591667 6.31662 0.5 6.08328 0.5 5.79995C0.5 5.51662 0.591667 5.28328 0.775 5.09995L5.375 0.499951C5.575 0.299951 5.80833 0.199951 6.075 0.199951C6.34167 0.199951 6.575 0.299951 6.775 0.499951L11.375 5.09995C11.5583 5.28328 11.65 5.51662 11.65 5.79995C11.65 6.08328 11.5583 6.31662 11.375 6.49995C11.1917 6.68328 10.9583 6.77495 10.675 6.77495C10.3917 6.77495 10.1583 6.68328 9.975 6.49995L7.075 3.59995V11.8C7.075 12.0833 6.97917 12.3208 6.7875 12.5125C6.59583 12.7041 6.35833 12.8 6.075 12.8C5.79167 12.8 5.55417 12.7041 5.3625 12.5125C5.17083 12.3208 5.075 12.0833 5.075 11.8V3.59995Z",
    fill: "#F85050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPositiveRed);
export default __webpack_public_path__ + "static/media/arrow_positive_red.a5f4a1622c75065f57183aa3163783dc.svg";
export { ForwardRef as ReactComponent };